import React from 'react';

const MasterContracts = React.lazy(() =>
  import(
    /* webpackChunkName: "system-master-contracts" */ '../pages/master/MasterContracts'
  )
);

const Config = React.lazy(() =>
  import(/* webpackChunkName: "system-config" */ '../pages/master/Config')
);

const ExpiryDates = React.lazy(() =>
  import(
    /* webpackChunkName: "expiry-dates-page" */ '../pages/master/ExpiryDatesPage'
  )
);

const BrokerSettings = React.lazy(() =>
  import(
    /* webpackChunkName: "broker-settings-page" */ '../pages/master/BrokerSettingsPage'
  )
);

export default [
  {
    id: 'config',
    path: '/system/config',
    name: 'Config',
    component: Config,
    exact: true,
  },
  {
    id: 'master-contracts',
    path: '/system/master-contracts',
    name: 'Master Contracts',
    component: MasterContracts,
    exact: true,
  },
  {
    id: 'expiry-dates',
    path: '/system/expiry-dates',
    name: 'Expiry Dates',
    component: ExpiryDates,
    exact: true,
  },
  {
    id: 'broker-settings',
    path: '/system/broker-settings',
    name: 'Broker Settings',
    component: BrokerSettings,
    exact: true,
  },
];
